module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "light-dark-int"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_c('router-link', {
    staticClass: "img-container linkhome",
    attrs: {
      "id": "linkhome",
      "to": "/",
      "aria-label": "ir al inicio"
    }
  }, [_c('div', [_c('img', {
    staticClass: "ima-header hidden-xs-only",
    attrs: {
      "src": require("../../assets/logos-icons/davi-header.png"),
      "alt": ""
    }
  })])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_c('section', [_c('p', {
    staticClass: "text-xs-right user-info",
    attrs: {
      "aria-label": "informacion de usuario"
    }
  }, [_c('span', {
    staticClass: "nombre",
    attrs: {
      "aria-label": "Nombre del usuario"
    }
  }, [_c('strong', [_vm._v("Andres Martínez")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "curso",
    attrs: {
      "aria-label": "Nombre del curso"
    }
  }, [_vm._v("Entidades Financieras")]), _vm._v(" "), (_vm.screenTrack[0] >= 1) ? _c('span', {
    staticClass: "pantallas",
    attrs: {
      "aria-label": "Avance del curso"
    }
  }, [_vm._v(" / Pantalla\n            "), _c('strong', [_vm._v(_vm._s(_vm.screenTrack[0]))]), _vm._v(" de\n            "), _c('strong', [_vm._v(_vm._s(_vm.screenTrack[1]))])]) : _vm._e()])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5fc7180","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Header.vue
// module id = 1047
// module chunks = 1